import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'

import * as organisationModule from 'modules/organisation'
import * as userActions from 'actions/userActions'

export default compose(
  connect(
    // mapStateToProps
    (state) => {
      return {
        username: idx(state, _ => _.user.fullName) || null,
        organisations: idx(state, _ => _.organisation.items),
      }
    },
    // mapDispatchToProps
    (dispatch) => {
      const actions = {
        ...userActions,
        ...organisationModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    onLogoutPress: props => () => {
      props.actions.logoutUser()
    },
    onOrganisationPress: props => (organisation) => {
      props.actions.selectOrganisation(organisation)
    },
    onCreateOrganisationPress: props => () => {
      props.history.push('/account/create-project')
    },
    onMenuPress: props => (link) => {
      props.history.push(link)
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOrganisations()
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/account/AccountHome/AccountHome.enhancer.js